<template>
    <div id="contents">
        <div class="contents_wrap">
            <div v-if="['001', '002'].includes(gubunCd)">
                <h2 class="pg_title">First Approval Detail (Access Request)</h2>
                <!-- breadcrumbs -->
                <div class="bc_ico">
                    Home
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em> Engineer
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em> Mobile SVC
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em> First Approval Detail (Access Request)
                </div>
                <!-- //breadcrumbs -->
                <!-- Basic tit -->
                <div class="sub_tit">Basic</div>
                <!-- //Basic tit -->
                <!-- detail_Basic -->
                <table class="create_table">
                    <colgroup>
                        <col width="18%" />
                        <col width="*" />
                        <col width="18%" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td>{{requestData.NAME}}</td>
                            <th>English Name</th>
                            <td>{{requestData.ENAME}}</td>
                        </tr>
                        <tr v-if="requestData.COUNTRY_NAME">
                            <th>Country/Region</th>
                            <td>{{requestData.COUNTRY_NAME}}</td>
                            <th>Email</th>
                            <td>{{requestData.EMAIL}}</td>
                        </tr>
                        <!--
                        <tr>
                            <th>Cell Phone Number</th>
                            <td>{{requestData.PHONE_CELL_NO}}</td>
                            <th>Office Phone Number</th>
                            <td>{{requestData.PHONE_OFFICE_NO}}</td>
                        </tr>
                        <tr v-if="requestData.FAX_NO">
                            <th>Fax Number</th>
                            <td>{{requestData.FAX_NO}}</td>
                            <th></th>
                            <td></td>
                        </tr>
                        -->
                    </tbody>
                </table>
                <div class="btn_wrap_full topLine"></div>
                <!-- //detail_Basic -->

                <!-- Role tit -->
                <div>
                    <div class="sub_tit mt40">Role</div>
                    <!-- //Role tit -->
                    <!-- detail_Role -->
                    <table class="create_table">
                        <colgroup>
                            <col width="18%" />
                            <col width="*" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>User Role</th>
                                <td>{{getRoleName}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="btn_wrap_full topLine"></div>
                    <!-- //detail_Role -->
                </div>

                <!-- Additional tit -->
                <div class="sub_tit mt40">Additional</div>
                <!-- //Additional tit -->
                <!-- detail_Additional -->
                <table class="create_table">
                    <colgroup>
                        <col width="18%" />
                        <col width="*" />
                        <col width="18%" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                        <!--
                        <tr>
                            <th>Center Name</th>
                            <td>{{requestData.CNAME}}</td>
                            <th></th>
                            <td></td>
                        </tr>
                        <tr></tr>
                        <tr>
                            <th>Center Address</th>
                            <td colspan="3">
                                <table class="data_table_ty2">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="35%" />
                                        <col width="15%" />
                                        <col width="35%" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>Street</th>
                                            <td colspan="3">{{requestData.STREET}}</td>
                                        </tr>
                                        <tr>
                                            <th>City</th>
                                            <td>{{requestData.CITY}}</td>
                                            <th>Zip Code</th>
                                            <td>{{requestData.ZIPCODE}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <th>Contact Person</th>
                            <td>{{requestData.CONTACT_USER}}</td>
                            <th></th>
                            <td></td>
                        </tr>
                        -->
                        <tr>
                            <th>Purpose</th>
                            <td colspan="3">{{requestData.PURPOSE}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="btn_wrap_full topLine"></div>
                <!-- //detail_Additional -->

                <!-- Information tit -->
                <div class="sub_tit mt40">Approval Information</div>
                <!-- //Information tit -->
                <!-- detail_Information -->
                <table class="create_table">
                    <colgroup>
                        <col width="18%" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>Second Approver
                                <em class="txt_mandatory">*</em>
                            </th>
                            <td>
                                <input
                                    type="text"
                                    class="text_input"
                                    name="second_approver_user"
                                    placeholder
                                    maxlength="30"
                                    readonly="readonly"
                                    v-model="secondApproverUserId"
                                />
                                <!-- a
                                    href="javascript:"
                                    class="btn_white"
                                    title
                                    @click="onSearchIdClick"
                                >Search</a -->
                            </td>
                        </tr>
                        <tr v-if="['A04', 'A05', 'A08', 'A09'].includes(requestData.ROLE_CD)">
                            <th>Mac Address
                                <em class="txt_mandatory">*</em>
                            </th>
                            <td>
                                <input
                                    type="text"
                                    class="text_input"
                                    placeholder="00-00-00-00-00-00"
                                    maxlength="17"
                                    v-validation
                                    v-regex="'/[^0-9a-fA-F\-]/g'"
                                    v-model="macAddress"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- //detail_Information -->
            </div>
            <div v-else>
                <h2 class="pg_title">First Approval View (Other)</h2>
                <!-- breadcrumbs -->
                <div class="bc_ico">
                    Home
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em> Engineer
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em> Mobile SVC
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em> First Approval View (Other)
                </div>
                <!-- //breadcrumbs -->
                <!-- Basic tit -->
                <div class="sub_tit">Basic</div>
                <!-- //Basic tit -->
                <!-- detail_Basic -->
                <table class="create_table">
                    <colgroup>
                        <col width="18%" />
                        <col width="*" />
                        <col width="18%" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td>{{requestData.NAME}}</td>
                            <th>English Name</th>
                            <td>{{requestData.ENAME}}</td>
                        </tr>
                        <tr v-if="requestData.COUNTRY_NAME">
                            <th>Country/Region</th>
                            <td>{{requestData.COUNTRY_NAME}}</td>
                            <th></th>
                            <td></td>
                        </tr>
                        <!--
                        <tr>
                            <th>Cell Phone Number</th>
                            <td>{{requestData.PHONE_CELL_NO}}</td>
                            <th>Office Phone Number</th>
                            <td>{{requestData.PHONE_OFFICE_NO}}</td>
                        </tr>
                        <tr v-if="requestData.FAX_NO">
                            <th>Fax Number</th>
                            <td>{{requestData.FAX_NO}}</td>
                            <th></th>
                            <td></td>
                        </tr>
                        -->
                    </tbody>
                </table>
                <div class="btn_wrap_full topLine"></div>
                <!-- //detail_Basic -->

                <div>
                    <!-- Request Information tit -->
                    <div class="sub_tit mt40">Request Information</div>
                    <!-- //Request Information tit -->
                    <!-- detail_Request Information -->
                    <table class="create_table">
                        <colgroup>
                            <col width="18%" />
                            <col width="*" />
                            <col width="18%" />
                            <col width="*" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>Request Type</th>
                                <td>{{selectedRequestTypeName}}</td>
                                <th></th>
                                <td></td>
                            </tr>
                            <tr></tr>
                            <tr v-if="['003', '004'].includes(requestData.TYPE_CD)">
                                <th>ESN/IMEI Writing P/W</th>
                                <td>******************</td>
                            </tr>
                            <tr v-if="['006', '007'].includes(requestData.TYPE_CD)">
                                <th>Country/Region</th>
                                <td>
                                    <select :disabled="['004', '005'].includes(reqStatus)"
                                        class="slt_white w100"
                                        v-model="selectedCountry"
                                        v-validation
                                    >
                                        <option
                                            v-for="item in availableCountryList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr v-if="['008'].includes(requestData.TYPE_CD)">
                                <th>User Role</th>
                                <td>
                                    <select class="slt_white w100" v-model="selectedUserRole">
                                        <option
                                            v-for="item in availableUserRoleList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>Purpose</th>
                                <td colspan="3">{{requestData.PURPOSE}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- //detail_Additional -->
                </div>
                <!-- //detail_Information -->
            </div>

            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white" @click="onBackToList()">List</a>
                <div class="btn_right" v-if="requestData.STAT_CD === '001'">
                    <a href="javascript:" class="btn_white" title @click="onApproveClick">Approve</a>
                    <a href="javascript:" class="btn_blue" title @click="onRejectClick">Reject</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';

import { SDLUtil } from '@/utils';

import SearchIdPopup from './SearchIdPopup';

const arrayListToMap = item => {
    return {
        CODE_ID: item[1].replace(/\"/g, ''),
        CODE_NAME: item[0].replace(/\"/g, ''),
    };
};

const REDO_SEARCH = true;

export default {
    name: 'hhp-first-approval-view',
    components: {},
    props: ['gubunCd', 'seqNo', 'onBackToList'],
    created() {},
    mounted() {
        this.init();
    },
    computed: {
        getRoleName() {
            const found = this.availableUserRoleList.find(item => item.CODE_ID === this.requestData.ROLE_CD);
            return found ? found.CODE_NAME : '';
        },
        selectedCountryName() {
            const found = this.availableCountryList.find(item => item.CODE_ID === this.selectedCountry);
            return found ? found.CODE_NAME : '';
        },
        selectedRequestTypeName() {
            const found = this.availableRequestTypeList.find(item => item.CODE_ID === this.selectedRequestType);
            return found ? found.CODE_NAME : '';
        },
    },
    data() {
        return {
            availableCountryList: [],
            availableRequestTypeList: [],
            availableUserRoleList: [],

            selectedCountry: '',
            selectedRequestType: '',
            selectedUserRole: '',

            secondApproverUserId: '',
            macAddress: '',
            reqStatus: '', // ApprovalStatus: 001=Requested, 005:Second Reject

            requestData: {
                //  SEQ_NO, USER_ID, IMEI_PASS, PIN, GUBUN_CD, NAME, ENAME, COUNTRY_CD
                //  , COUNTRY_NAME
                //  , PHONE_CELL_NO, PHONE_OFFICE_NO, FAX_NO, EMAIL, ROLE_CD, TYPE_CD,
                //   STAT_CD, CNAME, STREET
                //  , CITY, ZIPCODE, CONTACT_USER, PURPOSE, REQ_TIME, APP_USER_ID,
                //  APP_TIME, APP_COMMENT, COMP_USER_ID
                //  , COMP_TIME, COMP_COMMENT, REQ_USER_IP,
                //   G_USE_YN,
                //  MAC_ADD
                // G_USE_YN: "Y"
                // USER_ID: "je0625.kim"
                // EMAIL: "je0625.kim@aaa.aa"
                // COUNTRY_CD: "AG"
                // REQ_USER_IP: "127.0.0.1"
                // SEQ_NO: 6609021
                // ROLE_CD: "A09"
                // COUNTRY_NAME: "ANTIGUA and BARBUDA"
                // STAT_CD: "001"
                // PHONE_OFFICE_NO: "1234"
                // ENAME: "je kim"
                // GUBUN_CD: "003"
                // REQ_TIME: "Apr 21, 2020 3:42:04 PM"
                // NAME: "김정은"
                // APP_USER_ID: "sy4654.moon"
                // TYPE_CD: "007"
                // PHONE_CELL_NO: "1234"
                // COMP_USER_ID: "sy4654.moon"
            },
        };
    },
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            const { row, reqCountryList, reqTypeList, userRoleList } = await this.fetchData();

            this.setRequestData(row[0]);
            this.setAvailableCountryList(reqCountryList);
            this.setAvailableRequestTypeList(reqTypeList);
            this.setAvailableUserRoleList(userRoleList);

            SDLUtil.showLoadingBar(false);
        },
        fetchData() {
            const url = `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/FirstApproval/FirstApprovalDetail.skp`;
            const params = {
                SEQ_NO: this.seqNo,
                GUBUN_CD: this.gubunCd,
            };

            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(url, { params })
                    .then(res => {
                        console.log('DATA', res.data);
                        return res.data;
                    })
                    .catch(err => {
                        if (err.data.error.code === 'HHP_INVALID_REQUEST') {
                            SDLUtil.showLoadingBar(false);
                            SDLUtil.alert({
                                title: 'Deleted User',
                                msg: `Requesters's account has been deleted`,
                                onOkEvt: () => {
                                    if (this.onBackToList) {
                                        this.onBackToList();
                                    }
                                },
                            });
                            return null;
                        }
                    })
            );
        },
        setRequestData(data) {
            // G_USE_YN: "Y"
            // USER_ID: "je0625.kim"
            // EMAIL: "je0625.kim@aaa.aa"
            // COUNTRY_CD: "AG"
            // REQ_USER_IP: "127.0.0.1"
            // SEQ_NO: 6609021
            // ROLE_CD: "A09"
            // COUNTRY_NAME: "ANTIGUA and BARBUDA"
            // STAT_CD: "001"
            // PHONE_OFFICE_NO: "1234"
            // ENAME: "je kim"
            // GUBUN_CD: "003"
            // REQ_TIME: "Apr 21, 2020 3:42:04 PM"
            // NAME: "김정은"
            // APP_USER_ID: "sy4654.moon"
            // TYPE_CD: "007"
            // PHONE_CELL_NO: "1234"
            // COMP_USER_ID: "sy4654.moon"
            this.requestData = data;

            this.selectedCountry = data.COUNTRY_CD;
            this.selectedUserRole = data.ROLE_CD;
            this.selectedRequestType = data.TYPE_CD;
            this.secondApproverUserId = data.COMP_USER_ID;
            this.macAddress = data.MAC_ADD || '';
            this.reqStatus = data.STAT_CD;
        },
        setAvailableCountryList(list) {
            this.availableCountryList = list
                .map(arrayListToMap)
                .filter(item => item.CODE_ID.toUpperCase() !== 'SELECT');
        },
        setAvailableRequestTypeList(list) {
            this.availableRequestTypeList = list
                .map(arrayListToMap)
                .filter(item => item.CODE_ID.toUpperCase() !== 'SELECT');
        },
        setAvailableUserRoleList(list) {
            this.availableUserRoleList = list
                .map(arrayListToMap)
                .filter(item => item.CODE_ID.toUpperCase() !== 'SELECT');
        },
        onApproveClick() {
            this.approve();
        },
        onRejectClick() {
            this.reject();
        },
        prepParams() {
            const params = {
                // STAT_CD: 001
                // GUBUN_CD: 003
                // SEQ_NO: 6609021
                // comment:
                // type_cd: 007
                // change_imei_pass:
                // change_country_cd: YU
                // userRole_cd: A09
                // GUBUN_CD
                // SEQ_NO
                // userRole_cd
                GUBUN_CD: this.gubunCd,
                SEQ_NO: this.seqNo,
                comment: '', // Comment feature is no longer used
                userRole_cd: this.selectedUserRole,
                change_country_cd: this.selectedCountry,
                second_approver_user: this.secondApproverUserId,
                type_cd: this.selectedRequestType,
                mac_add: this.macAddress.toUpperCase(),
                // ['001', '002'].includes(this.gubun_cd) {
                //     second_approver_user
                // }
                // if(param.get("gubun_cd").equals("001")||param.get("gubun_cd").equals("002")){
                //     param.put("second_approver_user", StringUtil.fixNull(request.getParameter("second_approver_user")));
                // }
            };
            return params;
        },
        async approve() {
            if (this.requestData.STAT_CD !== '001') {
                SDLUtil.alert({
                    title: 'Already Processed!',
                    msg: 'This request has been already processed.',
                });
                return;
            }

            if (['A04', 'A05', 'A08', 'A09'].includes(this.requestData.ROLE_CD)
                && ['001', '002'].includes(this.gubunCd))
            {
                const regExp = /:/g;
                this.macAddress = this.macAddress.trim().toUpperCase().replace(regExp, '-').substr(0, 17);

                if (this.macAddress.length < 17) {
                    SDLUtil.alert({
                        title: 'Invalid input!',
                        msg: 'Mac Address is required for this request.',
                    });
                    return;
                }
            }

            const params = this.prepParams();
            SDLUtil.showLoadingBar(true);
            const data = await this.postApprove(params);
            SDLUtil.showLoadingBar(false);
            if (data.result === true) {
                SDLUtil.alert({
                    title: 'Approved!',
                    msg: 'Request has been approved.',
                    onOkEvt: () => {
                        this.onBackToList(REDO_SEARCH);
                    },
                });
            } else {
                SDLUtil.alert({
                    title: 'Failed!',
                    msg: 'Could not approve due to an unknown error.'
                        + '<br>Request an Admin to ensure that you have the right role code under \'Approval Management\'',
                    onOkEvt: () => {
                        this.onBackToList();
                    },
                });
            }
        },
        async reject() {
            if (this.requestData.STAT_CD !== '001') {
                SDLUtil.alert({
                    title: 'Already Processed!',
                    msg: 'This request has been already processed.',
                });
                return;
            }
            const params = this.prepParams();
            SDLUtil.showLoadingBar(true);
            const result = await this.postReject(params);
            SDLUtil.showLoadingBar(false);
            if (result) {
                SDLUtil.alert({
                    title: 'Rejected!',
                    msg: 'Request has been rejected.',
                    onOkEvt: () => {
                        this.onBackToList(REDO_SEARCH);
                    },
                });
            } else {
                SDLUtil.alert({
                    title: 'Failed!',
                    msg: 'Could not reject due to an unknown error.',
                    onOkEvt: () => {
                        this.onBackToList();
                    },
                });
            }
        },
        postApprove(params) {
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/FirstApproval/ApprovalProc.skp`,
                    qs.stringify(params),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(res => {
                    console.log('ApprovalProc Res ==> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('ApprovalProc Err ==> ', err);
                    return err;
                });
        },
        postReject(params) {
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/FirstApproval/RejectProc.skp`,
                    qs.stringify(params),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(res => {
                    console.log('Reject Res ==> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('Reject Err ==> ', err);
                    return err;
                });
        },
        onSearchIdClick() {
            this.openSearchIdPopup();
        },
        openSearchIdPopup() {
            SDLUtil.show(
                SearchIdPopup,
                {
                    title: 'SearchId',
                    onUserSelect: userId => {
                        this.secondApproverUserId = userId;
                    },
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            // const targetUrl = `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/SearchId.skp?parentName=second_approver_user`;
            // const typeoption = "menubar=no, width=530px, height=300px, resizable=no, scrollbars=yes";
            // window.open(targetUrl, "searchId", typeoption);
        },
        formatMacAddress(event) {
            console.log('event', event);
            // this.macAddress = this.macAddress.replace(/(.{2})/g,"$1-")

        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/approvalManagement/FirstApprovalView.vue